export default "__VITE_ASSET__DipYBleo__"